module.exports = __webpack_public_path__ + "img/History.f78cafcd.svg";